import { createContext } from 'react';
import {
	IVideos,
	IDataGetRestaurantsByIDsCustomersForVideos,
	IDataGetVideosByIDsRestaurantsForVideos,
	IVideosByIDsRestaurantsForVideos,
} from 'types';
import { IDataGetCustomersForAssignVideos } from 'types';

export type TSelectedItem = Nullable<string>;
export type TVideosSortBy =
	| ''
	| 'NameA-Z'
	| 'NameZ-A'
	| 'CategoriesA-Z'
	| 'CategoriesZ-A'
	| 'StudiosA-Z'
	| 'StudiosZ-A';
export type TActiveItemToDisplay = 'customers' | 'restaurants' | 'videos';
export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSendChanges' | 'success' | 'error';
export interface IIDsSelectedItems {
	[key: string]: boolean; // key - is the ID and boolean means open or closed tab status.
}
export interface IVideosWithAdditionalField extends IVideosByIDsRestaurantsForVideos {
	isAddedDishFromList: boolean;
}
export interface IVideosWithAdditionalProperty extends IDataGetVideosByIDsRestaurantsForVideos {
	isChanged: boolean;
	videos: IVideosWithAdditionalField[];
}
export type TCountOfItems = '12' | '24' | '48';

export interface IVideosAssignmentState {
	videosForAssign: IVideos;
	searchString: string;
	searchStringForAllCustomers: string;
	searchStringForRestaurants: string;
	searchStringForVideos: string;
	selectedStudio: TSelectedItem;
	selectedCategory: TSelectedItem;
	isUnassignedVideos: boolean;
	sortBy: TVideosSortBy;
	IDsSelectedVideos: string[];
	activeItemToDisplay: TActiveItemToDisplay;
	isShowBreadcrumbs: boolean;
	allCustomers: IDataGetCustomersForAssignVideos[];
	IDsSelectedCustomers: IIDsSelectedItems;
	restaurants: IDataGetRestaurantsByIDsCustomersForVideos[];
	IDsSelectedRestaurants: IIDsSelectedItems;
	videos: IVideosWithAdditionalProperty[];
	typeOfModalWindow: TTypeOfModalWindow;
	currentPage: number;
	countOfItems: TCountOfItems;
}

export const videosAssignmentInitialState: IVideosAssignmentState = {
	videosForAssign: { videosCount: 0, videos: [] },
	searchString: '',
	searchStringForAllCustomers: '',
	searchStringForRestaurants: '',
	searchStringForVideos: '',
	selectedStudio: null,
	selectedCategory: null,
	isUnassignedVideos: false,
	sortBy: '',
	IDsSelectedVideos: [],
	activeItemToDisplay: 'customers',
	isShowBreadcrumbs: false,
	allCustomers: [],
	IDsSelectedCustomers: {},
	restaurants: [],
	IDsSelectedRestaurants: {},
	videos: [],
	typeOfModalWindow: null,
	currentPage: 1,
	countOfItems: '12',
};

export interface IVideosAssignmentContext extends IVideosAssignmentState {
	changeSearchString(value: string): void;
	changeSearchStringForAllCustomers(value: string): void;
	changeSearchStringForRestaurants(value: string): void;
	changeSearchStringForVideos(value: string): void;
	setStudio(value: TSelectedItem): void;
	setCategory(value: TSelectedItem): void;
	toggleUnassignedVideos(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TVideosSortBy): void;
	setIDsSelectedVideos(value: string[]): void;
	changeActiveItemToDisplay(value: TActiveItemToDisplay): void;
	setShowBreadcrumbs(value?: boolean): void;
	setIDsSelectedCustomers(value: IIDsSelectedItems, isUpdateRestaurantsList: boolean): Promise<void>;
	setIDsSelectedRestaurants(value: IIDsSelectedItems, isUpdateVideosList: boolean): Promise<void>;
	addSelectedVideosToRestaurant(): void;
	deleteVideoFromRestaurant(restaurantID: string, videoID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeCurrentPage(page: number): void;
	resetChanges(): void;
	sendChanges(): Promise<void>;
	updateModuleDataAfterSaving(): void;
}

export const VideosAssignmentContext = createContext<IVideosAssignmentContext>({
	changeSearchString: () => undefined,
	changeSearchStringForAllCustomers: () => undefined,
	changeSearchStringForRestaurants: () => undefined,
	changeSearchStringForVideos: () => undefined,
	setStudio: () => undefined,
	setCategory: () => undefined,
	toggleUnassignedVideos: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setIDsSelectedVideos: () => undefined,
	changeActiveItemToDisplay: () => undefined,
	setShowBreadcrumbs: () => undefined,
	setIDsSelectedCustomers: async () => undefined,
	setIDsSelectedRestaurants: async () => undefined,
	addSelectedVideosToRestaurant: () => undefined,
	deleteVideoFromRestaurant: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeCurrentPage: () => undefined,
	resetChanges: () => undefined,
	sendChanges: async () => undefined,
	updateModuleDataAfterSaving: () => undefined,
	...videosAssignmentInitialState,
});
